import { WmsService } from '../resource'

const  WmsPromotionModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    createData ({ commit, state }, data) {
        return WmsService.PromotionCreate(data)
    },
    deleteData ({ commit, state }, data) {
        return WmsService.PromotionDelete(data.id)
    },
    async listData ({ commit, state }) {
      try{

      
        const data = await WmsService.PromotionList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    }
  }
}

export default WmsPromotionModule
